import { Box } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useState } from 'react';
import AllTenure from '../../component/AllTenure'
import axios from 'axios'
import { Auth } from '../../component/Auth';
const TenuresAll = () => {
  const [tData, setTData] = useState([]);
  const [isLoading, setIsLoading] = useState({loading: true, error: false})

  useEffect(() => {
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `${process.env.REACT_APP_RALCO_API_URL}/api/tenure`,
        headers: {
          'Authorization': Auth()
        },
      };
      
      axios.request(config)
      .then((response) => {
        setTData(response.data);
        setIsLoading({loading: false, error: false})
      })
      .catch((error) => {
        console.log(error);
        setIsLoading({loading: false, error: true})
      });
      
  }, [])



  return (
    <Box p={5} flex="1" w={'100%'}>
      <AllTenure
        title={"All Tenures"}
        head={["Tenure ID", "Order" , "Tenure Type", "Tenure Period" , "Expiry Date", "Tenure Status", ""]}
        data={tData}
        isLoading={isLoading}
      />
    </Box>
  )
}

export default TenuresAll
